import { styled } from '@mui/material';

export const StyledContainer = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: '100px',
  };
});

export const StyledTitle = styled('div')(() => {
  return {
    paddingBottom: '8px',
    marginTop: '100px',
  };
});

export const StyledSubTitle = styled('div')(() => {
  return {
    maxWidth: '837px',
  };
});

export const StyledCardsWrapper = styled('div')(() => {
  return {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '12px',
    paddingTop: '60px',
  };
});
